import { useApi } from '@/api';
import { ChartTimeFilter, HypeCard } from '@/components';
import { Flex, ChartSkeleton, DisplaySwitch } from '@blockanalitica/ui';
import { useMemo, useState } from 'react';
import OverviewGraphs from './OverviewGraphs';

type OverallHistory = {
  date: string;
  tvl: string;
  total_supply: string;
  total_borrow: string;
};

export default function OverviewGraphTabs() {
  const [activeDisplayOption, setActiveDisplayOption] =
    useState('total_supply');
  const [chartDaysAgo, setChartDaysAgo] = useState('30');
  const displayOptions = useMemo(
    () => [
      { key: 'total_supply', value: 'Market Size' },
      { key: 'tvl', value: 'TVL' },
      { key: 'total_available', value: 'Available' },
      { key: 'total_borrow', value: 'Borrow' }
    ],
    []
  );

  const [data, error] = useApi<OverallHistory[]>({
    url: '/overall/history/',
    queryParams: {
      days_ago: chartDaysAgo
    }
  });

  if (error) {
    throw error;
  }

  if (!data) {
    return <ChartSkeleton />;
  }

  return (
    <HypeCard
      header={
        <Flex
          justifyContent="space-between"
          alignItems={['center', 'flex-start']}
          flexDirection={['column', 'row']}
          gap={['xs', 'm']}>
          <DisplaySwitch
            data={displayOptions}
            activeOption={activeDisplayOption}
            onChange={setActiveDisplayOption}
          />
          <ChartTimeFilter
            activeOption={chartDaysAgo}
            onChange={setChartDaysAgo}
          />
        </Flex>
      }>
      <OverviewGraphs
        data={data}
        type={activeDisplayOption}
        chartDaysAgo={chartDaysAgo}
      />
    </HypeCard>
  );
}
